import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actions } from '../../modules/Actions';

export interface MailStopState {
  customerId: number,
  token: String,
  hit: number
}

export const initialState: MailStopState = {
    customerId: 0,
    token: '',
    hit: 0,
};

export const MailStopReducer = reducerWithInitialState(initialState).case(
  actions.fetchMailStop,
  (state: MailStopState, payload: MailStopState) => {
    return payload;
  }
);
